export const styles = {
  container: {
    width: "100%",
  },
  Section: {
    transition: "0.3s",
    overflow: "hidden",
    height: "100%",
    borderRadius: "var(--inyc-radius-sm)",
    backgroundColor: "white",
    border: "1px solid var(--inyc-divider)",
    boxShadow: "var(--inyc-shadow-sm)",
  },

  expandIcon: {
    height: "40px",
    width: "40px",
  },
  SplitContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    flexWrap: "wrap",
  },
  SplitSection: {
    width: "50%",
    minWidth: 600,
    height: "100%",
    padding: 20,
  },
  SplitSectionMobile: {
    minWidth: "100%",
  },
  SectionTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: 40,
    gap: "var(--inyc-space-20)",
    cursor: "pointer",
    fontSize: "3rem",
    color: "rgba(0,0,0,0.7)",
    margin: "var(--inyc-space-40) var(--inyc-space-32)",
  },
  EventAddOptions: {
    padding: "0",
    paddingTop: "var(--inyc-space-32)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "var(--inyc-space-32)",
  },
  mediumTitle: {
    margin: "-40px var(--inyc-space-20) var(--inyc-space-48) var(--inyc-space-48)",
    fontSize: 35,
    backgroundColor: "white",
    padding: "0 var(--inyc-space-20)",
    width: "fit-content",
  },
  EventLocationOptions: {
    marginBottom: "var(--inyc-space-32)",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "var(--inyc-space-20)",
  },
  inputLabel: {
    fontSize: 20,
  },
  FlexInputContainer: {
    width: "fit-content",
    display: "flex",
    whiteSpace: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "var(--inyc-space-20)",
  },
  flexInput: {
    maxWidth: "500px",
    padding: 0,
  },
  mapContainer: {
    padding: 0,
    minHeight: "500px",
    marginTop: "0px",
    height: "100%",
    display: "flex",
    position: "relative",
    justifyContent: "center",
  },
  mapStyle: {
    maxWidth: "500px",
    // boxShadow: "var(--inyc-shadow-md)",
    border: "1px solid var(--inyc-divider)",
  },
  PostButton: {
    margin: "var(--inyc-space-20) auto var(--inyc-space-20) auto",
    width: "100%",
  },
  borderSecion: {
    padding: 20,
    margin: "var(--inyc-space-48) 0",
    border: "1px solid var(--inyc-divider)",
  },
  datePickerContainer: {
    width: "100%",
    // backgroundColor: "black",
    border: "1px solid var(--inyc-divider)",
    // color: "var(--inyc-on-fill)",
    color: "rgba(0,0,0,0.7)",
    fontFamily: "Primary",
    minHeight: "50px",
    backgroundColor: "white",
    fontSize: 17,
    padding: "var(--inyc-space-20) var(--inyc-space-40)",
    display: "flex",
    justifyContent: "flex-start",
  },
  LatLngInput: {
    border: "none",
    borderBottom: "1px solid var(--inyc-divider)",
  },
  CheckBoxContainer: {
    display: "flex",
    alignItems: "center",
    gap: "var(--inyc-space-20)",
  },
  CheckBoxInputLabel: {
  },
};
